const tables = [
  {
    name: "Name",
  },
  {
    name: "Code",
  },
  {
    name: "Description",
  },
  {
    name: "Status",
  },
  {
    name: "Created Date",
  },
  {
    name: "Action",
  },
];

export default tables;